export { default as QuickBookingRestC } from './QuickBookingRestC'
export { default as QuickBookingRestCSkeleton } from './Skeleton'
